<template>
  <div class="search-settings" @click.self="$emit('close')">
    <form @submit.prevent="action.search" method="post">
      <div class="formparts function mb8">
        <input 
          type="text" 
          v-model="state.keyword" 
          maxlength="50"
          placeholder="キーワードを入力（最大50文字）"
          @focus="$emit('handleFocusInput')" 
          @blur="$emit('handleFocusOutInput')" 
          ref="focusInput">
        <div @click="action.search" class="button" role="button"><FontawesomeIcon icon="search" class="icn" /></div>
      </div>
      <div class="search-settings-row">
        <div class="formparts checkbox mt20">
        </div>
        <span @click="action.searchReset" class="search-settings-clear">検索をクリア</span>
      </div>
    </form>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import { GuideSearch} from '@/logic/guide/GuideSearch'

export default defineComponent({

  setup (props, context) {
    
    return { ...GuideSearch(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.search-settings {
  position: fixed;
  z-index: $index-menu;
  height: 128px;
  transform: translate3d(0,100%,0);
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px 0 0 0;
  transition: transform .2s ease;
  &-row {
    position: relative;
  }
  &-clear {
    position: absolute;
    top: -2px;
    right: 0;
    color: $color-link;
  }
  .is-focused-input & {
    .search-settings-row {
      display: none;
    }
  }
}
</style>
